export const environment = {
  baseUrl: "http://dev-3.brightfunded2.com",
  production: false,
  devEnvUrl: "https://www.dev-3.brightfunded2.com",

  usersApiUrl: "https://api.dev-3.brightfunded2.com/users/2",
  landingPageUrl: "https://streamlined-tenure-344446.framer.app/",
  limitFingerprint: true,

  newChallengesApiUrl: "https://api.dev-3.brightfunded2.com/challenges/1",
  ftChallengesApiUrl: "https://api.dev-3.brightfunded2.com/ft-challenges/1",
  purchasesApiUrl: "https://api.dev-3.brightfunded2.com/purchases/1",
  contractsApiUrl: "https://api.dev-3.brightfunded2.com/contracts/1",
  payoutsApiUrl: "https://api.dev-3.brightfunded2.com/payouts/1",

  vouchersApiUrl: "https://api.dev-3.brightfunded2.com/vouchers/1",
  vouchersV2ApiUrl: "https://api.dev-3.brightfunded2.com/vouchers/2",
  statisticsApiUrl: "https://api.dev-3.brightfunded2.com/statistics/1",

  googlePayMerchantId: "BCR2DN5T53BIDGAY",
  nomuPayGatewayMerchantId: "8ac7a4c99b3491c6019b35600e780107",
  revolutPublicKey: "pk_2uHZs1F2ZxTbbpIvweF7JyDRSzclagiweknk7cL9n6Lg9c7Q",

  isInspect: true,
  title: "dev",

  firebaseConfig: {
    apiKey: "AIzaSyBjwDFODg2TAnAER9dgZwqid2atqp5DtYg",
    authDomain: "brightfunded-dev-3.firebaseapp.com",
    projectId: "brightfunded-dev-3",
    storageBucket: "brightfunded-dev-3.appspot.com",
    messagingSenderId: "195781189138",
    appId: "1:195781189138:web:9cf0f1f5a784cba09d82cb",
  },
  intercomAppId: "ivhgfmtk",
  recaptchaSiteKey: "6Lf3wSonAAAAAF_vy7Hg1-UJLDHMcmfGxLuSxJuS",
  googleTagManagerId: "GTM-WMH5WVKB",

  fpApiKey: "xvQLOrAkpoclfBXXCdal",
  fpRegion: "eu",
};
